export default __webpack_public_path__ + "static/media/mobile_logo.48667ea3.svg";